import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('button', 'modalAction', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    outline: 'none',
    textAlign: 'center',
    boxShadow: '2px 2px 0 rgb(0 0 0 / 10%)',
    borderStyle: 'solid',
    borderColor: '#dee2e6',
    borderRadius: '3px',
    borderWidth: '1px',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f8f9fa',
    minHeight: '24px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '8px',
    paddingRight: '8px',
    margin: '0 5px 0 0',
    cursor: 'pointer',
    hover: {
        borderColor: '#ebeef0',
        backgroundColor: '#fcfcfc',
    },
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalAction.tsx